/* globals dataLayer, adobe */
(function (window, angular, undefined) {
angular.module('formApp')
.controller('stepOneCtrl', ['$scope', '$rootScope', '$q', 'FormService', 'updateHeader', '$state', '$log', 'formData', 'scrollToPoint', '$timeout', 'errorHandler', 'LoadingInterceptor', '$stateParams', '$location', 'sessionService', 'dataLayerService',
function ($scope, $rootScope, $q, formService, updateHeader, $state, $log, formData, scrollToPoint, $timeout, errorHandler, loadingInterceptor, $stateParams, $location, sessionService, dataLayerService) {

$rootScope.firstPetNameSet = false;

var evt = new CustomEvent("currentStep", {detail: {step:"1"}});
window.dispatchEvent(evt);

    console.log('event dispatched', evt);
    $scope.campaign = sessionStorage.getItem('campaign');
    $scope.brav = sessionStorage.getItem('brav');

//AH-6124
var timeout = timeout ? clearTimeout(timeout) : null;
var env = ['localhost', 'quote-dev.petplan.co.uk', 'quote-int.petplan.co.uk'].includes(window.location.hostname);
angular.element(document).ready(function () {
  $scope.techError = sessionStorage.getItem("formStateUri") ? false : true;
    if (!env) {
        if (!sessionStorage.getItem("formStateUri")) {
            timeout = setTimeout(function () {
            $scope.techError = false;
            }, 14000);
        }
    }
    else {
        console.log('environment', env);
        $scope.techError = false;
    }
});

$scope.petNameQs = function (index) {

if($scope.formData.pets.length > 1){
$rootScope.singlePetQs = false;
updateHeader.petType = 'multipet';
var i;
for (i = 0; i < $scope.formData.pets.length; i++) {
    var multiPetName = $scope.formData.pets[i].details.name;

    if ($scope.formData.pets[i].details.name && index.$index === i){
        $rootScope.firstPetNameSet  = true;
        $rootScope.firstPetName = $scope.formData.pets[i].details.name;
        return multiPetName;
    }  
}

}
else{
$rootScope.singlePetQs = true;
var petName = $scope.formData.pets[0].details.name;

if ($scope.formData.pets[0].details.name && index.$index === 0){
    $rootScope.firstPetNameSet  = true;
    $rootScope.firstPetName  = petName;
    return petName;
}
else if ($location.search().petName && index.$index === 0){
        $rootScope.firstPetNameSet  = true;
        $rootScope.firstPetName = $location.search().petName;
        return $location.search().petName;
}
else{

    return '';
}
}
};

$scope.$watch('formData.pets[0].details.name', function() {
if ($scope.formData.pets[0].details && $scope.formData.pets[0].details.name) {
$rootScope.firstPetName = $scope.formData.pets[0].details.name;
$rootScope.firstPetNameSet  = true;
} else {
$rootScope.firstPetName = '';
$rootScope.firstPetNameSet  = false;
}
});

$scope.$watch('formData.pets[1].details', function(newVal, oldVal) {
if (newVal) {
$rootScope.singlePetQs = false;
} else {
$rootScope.singlePetQs = true;
}
});

$rootScope.journeyClass = 'single';
sessionService.start();

if (sessionStorage.getItem('eQuote') || sessionStorage.getItem('eCoverNote')) {
sessionStorage.removeItem('formStateUri');
sessionStorage.removeItem('retrieveQuote');
sessionStorage.removeItem('eQuote');
sessionStorage.removeItem('eCoverNote');
sessionStorage.removeItem('campaign');
sessionStorage.removeItem('brav');
sessionStorage.removeItem('eCoverJourney');
$scope.$parent.campaign = '';
$scope.$parent.brav = '';
}



//------------------------GA STUFF----------------------------//


$scope.$watch('gaPetPostition', function () {
dataLayer.push({
'event': 'dataAvailable',
'funnelName': parseInt($rootScope.campaignFunnel),
'funnelVersion': '1.0',
'funnelPageNumber': 1,
'petDetailsPosition': $scope.gaPetPostition,
'environment': window.location.hostname,
'bravCode': '',
'campaignCode': dataLayerService.campaignCode(),
'partnerName': dataLayerService.partnerName(),
});

});

$scope.gaPetPostition = 1;

$scope.petTypeQs = function (index) {
if ($scope.formData.pets[0].type && index.$index === 0){
    $scope.formData.pets[0].type = $scope.formData.pets[0].type;
}

else if ($location.search().petType && index.$index === 0) {
    $scope.formData.pets[0].type = $location.search().petType;

}
else{
    return false;
}                            
};

$scope.pushPet = function () {

dataLayer.push({
'event': 'dataAvailable',
'funnelName': parseInt($rootScope.campaignFunnel),
'funnelVersion': '1.0',
'funnelPageNumber': 1,
'petDetailsPosition': $scope.gaPetPostition,
'environment': window.location.hostname,
'bravCode': $scope.brav,
'campaignCode': dataLayerService.campaignCode(),
'partnerName': dataLayerService.partnerName(),
'numberOfPets': $scope.formData.pets.length,
'multipetFlag': dataLayerService.multiPetTest(),
});

};


//------------------------GA STUFF----------------------------//

if ($state.params.type === 'topNav') {
var navMethod = $state.params.type;
}

// This will only execute if we have come from step 5
if ($state.params.petToEdit) {
$timeout(function () {
var petToSCrollTo = "petAnchor" + $state.params.petToEdit;

scrollToPoint.scrollTo(petToSCrollTo, 20, 'id');
});
}

sessionStorage.setItem('currentRefreshState', 'step-1');

$scope.$watch('gatewayReady', function () {
if ($scope.gatewayReady === true && sessionStorage.getItem('formStateUri')) {
formService.setApplicationId(sessionStorage.getItem('formStateUri'));
loadingInterceptor.incrementRequests();
refresh().then(function(response) {
    loadingInterceptor.decrementRequests();
    $scope.formData.pets = response.data.application.pets;
    $scope.formData.cover = response.data.application.cover;
    $scope.gaPetPostition = 1;
    // update header page refresh
    if ($scope.formData.pets.length > 1) {
        updateHeader.petType = 'multipet';
    } else {
        updateHeader.petType = $scope.formData.pets[0].type;
    }
    // if the start date is in the past force the user to reselect
    if (moment($scope.formData.cover.startDate).isBefore(moment().format('YYYY-MM-DD'))) {
        delete $scope.formData.cover.startDate;
        $timeout(function () {
            scrollToPoint.scrollTo("coverStartDaterelday", 20, 'id');
            $scope.submitted = true;
        });
    }

    vpLoad();
});
}

if ($scope.gatewayReady === true && !sessionStorage.getItem('formStateUri')) {
vpLoad();
}

function refresh() {
return formService.getApplication();
}
});

$scope.coverStartDateMin = moment().format('YYYY-MM-DD');
$scope.coverStartDateMax = moment().add(1, 'year').format('YYYY-MM-DD');
$scope.dobDateMin = moment().format('YYYY-MM-DD');
$scope.dobDateMax = moment().subtract(16, 'year').startOf('year').format('YYYY-MM-DD');
$scope.formData = formData;
$scope.hideDiscount = sessionStorage.getItem('hideDiscount');

if (!sessionStorage.getItem('formStateUri')) {
var petValue = $location.search().petvalue;
if (['dog', 'cat', 'rabbit'].indexOf(petValue) !== -1) {
$scope.formData.pets[0].type = petValue;
sessionStorage.setItem('petType', petValue);
updateHeader.petType = petValue;
}

$scope.breed = $location.search().breed;
if (['beagle','border-collie','cockapoo','cocker-spaniel','dachshund','german-shepherd','golden-retriever','labradoodle','labrador','pomeranian','pug', 'shih-tzu'].indexOf($scope.breed) !== -1) {
sessionStorage.setItem('petBreed', $scope.breed);
updateHeader.petType = $scope.breed;
}
}

$scope.checkDOB = function (pet) {
if (pet.details !== undefined && pet.details.dateOfBirth !== undefined) {
if (pet.details.confirmation === 'Y'){
    delete pet.details.confirmation;
}
}
};

$scope.overSixMonths = function (pet) {
if (pet.details !== undefined && pet.details.dateOfBirth !== undefined) {
var dob = pet.details.dateOfBirth;
var diffMonths = moment().diff(moment(dob), 'months', true);
if (diffMonths > 6) {
    return true;
} else {
    return false;
}
}
};

$scope.setCoverDateInit = function () {
$scope.formData.cover.startDate = $scope.formData.cover.startDate || $scope.coverStartDateMin;
};

$scope.isFutureDate = function (date) {
return date && moment(date).isAfter(moment().format('YYYY-MM-DD'));
};

$scope.updateHeader = function (petType) {
console.log('update header');
var getBreed = sessionStorage.getItem('petBreed');
if (petType === 'remove')  {
sessionStorage.removeItem('petMultipet');
} else {    
if ($scope.formData.pets.length > 1) {
    console.log('multi header');
    sessionStorage.removeItem('petBreed');
    updateHeader.petType = 'multipet';
    sessionStorage.setItem('petMultipet', true);
} else {
    if (getBreed && petType === 'dog') {
        updateHeader.petType = getBreed;
    } else {       
        console.log('single header');                    
        updateHeader.petType = petType;
        sessionStorage.setItem('petType', petType);
    }
}
}                    
};

$scope.addPet = function () {
$scope.gaPetPostition = $scope.gaPetPostition + 1;
if ($scope.formData.pets.length < 5) {
$scope.formData.pets.push({});
}
$timeout(function () {
var petLength = $scope.formData.pets.length - 1,
    petID = 'pettype-petTypeDog[' + petLength + ']',
    focusPetSelect = document.getElementById(petID);
focusPetSelect.focus();
});
};

// post pet details in serial to maintain pet order in IFS
$scope.submit = function (e) {
e.preventDefault();
if (!$scope.techError) {
var petIndex = 0,
params = {};

if ($scope.campaign) {
params.campaign = $scope.campaign;
}
if ($scope.brav) {
params.brav = $scope.brav;
}

loadingInterceptor.incrementRequests();
formService.getApplicationId(params).then(function (response) {
formService.setApplicationId(response.applicationId);
processForm(petIndex);
}).catch(function (e) {
errorHandler.reportErrors(e, 'redirect', 'tech');
});
}
else{
    //console.log('AH-6124');
    clearTimeout(timeout);

    $state.go('tech-error', { forward: true });
}
};

function processForm(index) {
if (index === $scope.formData.pets.length) {
formService.postCover($scope.formData.cover).then(function success(response) {
    loadingInterceptor.decrementRequests();
    $state.go('step-2', { forward: true });

}, function failure(e) {
    errorHandler.reportErrors(e, 'redirect', 'tech');
});
} else {
var pet = $scope.formData.pets[index];
pet.details['spayedOrNeutered'] = 'N';
if (pet.uri) {
    formService.updatePetType(pet).then(function success() {
        return formService.updatePet(pet);
    }).then(function () {
        processForm(index + 1);
    }).catch(function (e) {
        errorHandler.reportErrors(e, 'redirect', 'tech', 'args');
    });
} else {
    formService.postPet(pet).then(function success(response, status) {
        if (response.data && response.data.uri) {
            pet.uri = response.data.uri.substr(-8) === '/details' ? response.data.uri.slice(0, -8) : response.data.uri;
            processForm(index + 1);
        }
    }, function failure(e) {
        errorHandler.reportErrors(e, 'redirect', 'tech');
    });
}
}
}

function reportErrors(fault) {
if (fault.message) {
$log.error(fault.message);
} else {
$log.error(JSON.stringify(fault));
}
}

$scope.focusPetSelector = function () {
$timeout(function () {
var focusPetSelect = document.getElementById('petTypeDog[' + formData.pets.length + ']');

focusPetSelect.focus();
});
};

function processPetDetails() {
var promises = [];
$scope.formData.pets.forEach(function (pet) {
if (pet.uri) {
    promises.push(formService.updatePet(pet, pet.uri, $scope.insuranceApplicationUri));
} else {
    promises.push(formService.postPet(pet, $scope.insuranceApplicationUri).then(function success(response, status) {
        if (response.data && response.data.uri) {
            pet.uri = response.data.uri.substr(-8) === '/details' ? response.data.uri.slice(0, -8) : response.data.uri;
        }
    }));
}
});
return promises;
}
// SESSIONCAM 
function vpLoad() {
if (window.sessionCamRecorder) {
if (window.sessionCamRecorder.createVirtualPageLoad) {
    window.sessionCamRecorder.createVirtualPageLoad('stepOne');
}
}
} 
}
]);
})(window, window.angular);